import { render, staticRenderFns } from "./DeliveryDefault.vue?vue&type=template&id=2db0f27c&scoped=true"
import script from "./DeliveryDefault.vue?vue&type=script&lang=ts"
export * from "./DeliveryDefault.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryDefault.vue?vue&type=style&index=0&id=2db0f27c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0f27c",
  null
  
)

export default component.exports